import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-wide"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.75C2 5.67893 3.67893 4 5.75 4H14.25C16.3211 4 18 5.67893 18 7.75V8H18.25C20.3211 8 22 9.67893 22 11.75V16.25C22 18.3211 20.3211 20 18.25 20H9.75C7.67893 20 6 18.3211 6 16.25V16H5.75C3.67893 16 2 14.3211 2 12.25V7.75ZM6 11.75V14.5H5.75C4.50736 14.5 3.5 13.4926 3.5 12.25V7.75C3.5 6.50736 4.50736 5.5 5.75 5.5H14.25C15.4926 5.5 16.5 6.50736 16.5 7.75V8H9.75C7.67893 8 6 9.67893 6 11.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlidesWide;
